import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccountDTO } from '../../../../shared/account-dto';
import { AccountService } from '../account.service';
import { CmsAuthService } from '../cms-auth.service';
import { resourceDict, VERSION_NUMBER } from '../cms/constants';
import { STORAGE_CMS } from '../constants';

@Component({
  selector: 'pv-cms-toolbar',
  templateUrl: './cms-toolbar.component.html',
  styleUrls: ['./cms-toolbar.component.scss']
})
export class CmsToolbarComponent implements OnInit {
  @Output() onToggleSnav: EventEmitter<void> = new EventEmitter<void>();
  account: AccountDTO;
  version = VERSION_NUMBER;
  deprecated = '';

  username: string;

  routes = [
    { wholesale_only: false, name: resourceDict.artist.title, routerLink: ['/cms', resourceDict.artist.route] },


    { name: resourceDict.album.title, routerLink: ['/cms', resourceDict.album.route], children: [
      { name: resourceDict.release.title, routerLink: ['/cms', resourceDict.release.route] },
      { name: resourceDict.track.title, routerLink: ['/cms', resourceDict.track.route] },
      { d2c_only: true, name: resourceDict.downloadLog.title, routerLink: ['/cms', resourceDict.downloadLog.route] },
      { name: resourceDict.publisher.title, routerLink: ['/cms', resourceDict.publisher.route] },
      { name: resourceDict.recordLabel.title, routerLink: ['/cms', resourceDict.recordLabel.route] },
    ]},

    { d2c_only: true, name: this.deprecated + resourceDict.news.title, routerLink: ['/cms', resourceDict.news.route] },
    { name: this.deprecated + resourceDict.product.title, routerLink: ['/cms', resourceDict.product.route], children: [
      { name: this.deprecated + resourceDict.productInstance.title, routerLink: ['/cms', resourceDict.productInstance.route] },
      { d2c_only: true, name: this.deprecated +  resourceDict.bundle.title, routerLink: ['/cms', resourceDict.bundle.route] },
      { name: this.deprecated + resourceDict.type.title, routerLink: ['/cms', resourceDict.type.route] },
      { wholesale_only: true, name: this.deprecated + resourceDict.wholesalePrice.title, routerLink: ['/cms', resourceDict.wholesalePrice.route] },
      { name: this.deprecated + resourceDict.prodList.title, routerLink: ['/cms', resourceDict.prodList.route] },
      { name: this.deprecated + resourceDict.sale.title, routerLink: ['/cms', resourceDict.sale.route] },
    ]},

    { name: this.deprecated + resourceDict.order.title, routerLink: ['/cms', resourceDict.order.route], children: [
      { name: this.deprecated + resourceDict.customer.title, routerLink: ['/cms', resourceDict.customer.route] },
      { name: this.deprecated + resourceDict.couponBatch.title, routerLink: ['/cms', resourceDict.couponBatch.route] },
      { name: this.deprecated + resourceDict.transaction.title, routerLink: ['/cms', resourceDict.transaction.route] },
      { name: this.deprecated + resourceDict.declinedTransaction.title, routerLink: ['/cms', resourceDict.declinedTransaction.route] },
      { name: this.deprecated + resourceDict.shippingRate.title, routerLink: ['/cms', resourceDict.shippingRate.route] },
      { name: this.deprecated + 'Order Dashboard', routerLink: ['/cms', 'dashboard'] },
    ]},


    { d2c_only: true, name: this.deprecated + resourceDict.webpage.title, routerLink: ['/cms', resourceDict.webpage.route], children: [
      { name: this.deprecated + resourceDict.alert.title, routerLink: ['/cms', resourceDict.alert.route] },
      { d2c_only: true, name: this.deprecated + resourceDict.banner.title, routerLink: ['/cms', resourceDict.banner.route] },
      { d2c_only: true, name: this.deprecated + resourceDict.pageLayout.title, routerLink: ['/cms', resourceDict.pageLayout.route], queryParams: { page_type_cd: "HOME"} },
    ]},


    { routerLink: ['/cms', 'tools'], name: 'Tools', children: [] },
    { routerLink: ['/cms', 'objects'], name: 'Objects', children: [] },
    { routerLink: ['/cms', 'reports'], name: 'Reports', children: [] },

    { routerLink: ['/cms', 'login'], name: 'Log In', children: [] },
  ]

  constructor(
    private cmsAuthService: CmsAuthService,
    private accountService: AccountService
  ) { }

  ngOnInit()
  {
    this.hideWholesale();
    this.username = localStorage.getItem(STORAGE_CMS);
    this.updateLogin();

    this.cmsAuthService.watchLogin()
      .subscribe(() => {
        this.username = localStorage.getItem(STORAGE_CMS)
        this.updateLogin()
      });

    // Subscribe to account
    this.account = this.accountService.account;

    this.accountService.accountSubject
      .subscribe(account => this.account = account);

    // #1290 deprecated menu items post-Shopify
    this.afterLoad();
  }

  // #1290 deprecated menu items post-Shopify
  afterLoad()
  {
    if (this.account.id == 1)
    {
      const orderRoute = this.routes.find(r => r.name.includes('Order'));
      orderRoute.name= '[Orders]';

      const newsRoute = this.routes.find(r => r.name.includes('News'));
      newsRoute.name= '[News]';

      const productRoute = this.routes.find(r => r.name.includes('Prod'));
      productRoute.name= '[Products]';

      const webpageRoute = this.routes.find(r => r.name.includes('Webpage'));
      webpageRoute.name= '[Webpages]';

      const toolsRoute = this.routes.find(r => r.name.includes('Tool'));
      toolsRoute.name= '[Tools]';

      const objectsRoute = this.routes.find(r => r.name.includes('Objects'));
      objectsRoute.name= '[Objects]';

      const reportsRoute = this.routes.find(r => r.name.includes('Reports'));
      reportsRoute.name= '[Reports]';
    }
  }

  toggleSnav() {
    this.onToggleSnav.emit();
  }

  updateLogin()
  {
    const loginRoute = this.routes.find(r => r.routerLink.includes('login'))

    loginRoute.name = this.username ? 'Log Out' : 'Log In';


  }

  hideWholesale() {
    if ((window as any).disabled_d2c) {
      this.routes = this.routes.filter(r => !r.d2c_only)
      this.routes.forEach((r: any) => r.children && (r.children = r.children.filter(c => !c.d2c_only)))
    }
    if ((window as any).disabled_wholesale) {
      this.routes = this.routes.filter(r => !r.wholesale_only)
      this.routes.forEach((r: any) => r.children && (r.children = r.children.filter(c => !c.wholesale_only)))
    }

    if ((window as any).fuga_feature)
    {
      this.routes = this.routes.filter(r => !r.wholesale_only)
    }
  }
}
